$shm_hitalama_map_widget_float_method $shm_hitalama_map_widget_float
	head_showed true
	tools_custom /
		<= Font_size_tool $shm_hitalama_map_fontsize
			font_size? <=> font_size? 14
	head /
		<= Method_title $mol_view
			sub <= method_title_sub
		<= Decorator $mol_select
			value? <=> decorator? \mem
			dictionary <= decorator_options *
				mem \mem
				mem_key \mem_key
				process_mem \process_mem
				view \view
				view_key \view_key
				action \action
				process_action \process_action
				none \none
	controls /
		<= Textarea $shm_hitalama_textarea
			hint \method body
			sidebar_showed true
			value? <=> code? \
			spellcheck false
			style *
				fontSize <= font_size_px
	method_title_sub /
		<= Title_text $mol_text
			text <= title
			style *
				fontSize \22px
		<= Title_edit $mol_button_minor
			sub /
				<= Title_edit_icon $mol_icon_pencil
			click? <=> title_edit? null
	method_title_edit_sub /
		<= Title_input $mol_string
			value? <=> title_draft? \
			submit? <=> title_apply? null
			style *
				fontSize \22px
		<= Title_apply $mol_button_minor
			sub /
				<= Title_apply_icon $mol_icon_check
			click? <=> title_apply? null
		<= Title_cancel $mol_button_minor
			sub /
				<= Title_cancel_icon $mol_icon_close
			click? <=> title_cancel? null
